import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { StyledCard } from './StyledComponents';

const propTypes = {
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

const defaultProps = {
  isDisabled: false,
  children: '',
  className: '',
};

const InteractiveCard = ({ isDisabled, children, className }) => (
  <StyledCard className={cx(className, 'InteractiveCard')} cardType="secondary" isDisabled={isDisabled}>
    {children}
  </StyledCard>
);

InteractiveCard.propTypes = propTypes;
InteractiveCard.defaultProps = defaultProps;

export default InteractiveCard;
